import * as React from 'react';

import {
	Root,
	ThumbVertical,
	ThumbHorizontal,
} from './styled';


export type ScrollableViewProps = {
	ref?: any;
	width?: number | string;
	height?: number | string;
	autoHide?: boolean;
	autoHideTimeout?: number;
	autoHideDuration?: number;
	autoHeight?: boolean;
	autoHeightMin?: number;
	autoHeightMax?: number;
	thumbMinSize?: number;
	universal?: boolean;
	style?: React.CSSProperties;
	onScroll?: () => void;
	onScrollFrame?: () => void;
	onScrollStar?: () => void;
	onScrollStop?: () => void;
	onUpdate?: () => void;
	renderView?: () => React.ReactNode;
	renderTrackHorizontal?: () => React.ReactNode;
	renderTrackVertical?: () => React.ReactNode;
	renderThumbHorizontal?: () => React.ReactNode;
	renderThumbVertical?: () => React.ReactNode;
}

const ScrollableView: React.SFC<ScrollableViewProps> = React.forwardRef(({ style, width, height, ...rest }, ref) => {
	return (
		<Root
			ref={ref}
			renderThumbVertical={props => <ThumbVertical {...props} />}
			renderThumbHorizontal={props => <ThumbHorizontal {...props} />}
			style={style}
			{...rest}>
		</Root>
	);
});

ScrollableView.displayName = 'ScrollableView';
ScrollableView.defaultProps = {
	autoHeight: false
};

export default ScrollableView;
